/* Card Finder: AI shopping chat for The Ballers Bank. Talks to the Card Finder server; adds to the real Shopify cart.
   Any element with data-card-finder-ask opens the chat; data-cf-query (or the input inside a
   [data-card-finder-form]) is sent as the shopper's question. */
(() => {
  const root = document.querySelector("[data-card-finder]");
  if (!root) return;
  const API = (root.dataset.api || "").replace(/\/+$/, "");
  const SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const T = JSON.parse(root.querySelector("[data-cf-strings]").textContent);
  const KEY = "bb-card-finder-v1";
  const $ = (sel) => root.querySelector(sel);
  const launch = $(".cf__launch"), panel = $(".cf__panel"), log = $(".cf__log"), form = $(".cf__form"), input = $(".cf__input"), sendBtn = $(".cf__send");
  const money = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n) || 0);
  const store = { get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  let history = [];
  try { history = JSON.parse(store.get(KEY) || "[]") || []; } catch (e) { history = []; }
  const save = () => store.set(KEY, JSON.stringify(history.slice(-24)));
  let busy = false;

  // Usage counts for the weekly Card Finder report (no personal data is sent).
  const ping = (body) => { if (!API) return; try { fetch(API + "/api/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {}); } catch (e) {} };
  // Hidden cart note so orders that include a Card Finder add can be counted. Underscore keeps it out of checkout.
  const tagCart = () => fetch(SHOP_ROOT + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: { _card_finder: "1" } }) }).catch(() => {});

  // One gentle pulse per visit, after the shopper has been on the page a few seconds.
  if (!store.get(KEY + "-pulsed")) {
    setTimeout(() => { if (panel.hidden) { launch.classList.add("cf__launch--pulse"); store.set(KEY + "-pulsed", "1"); } }, 6000);
  }

  // On phones the chat is full screen: the phone's Back button closes it instead of leaving the page.
  const isPhone = () => window.matchMedia("(max-width: 600px)").matches;
  const onChatEntry = () => Boolean(window.history.state && window.history.state.cfChat);
  function open() { if (!store.get(KEY + "-opened")) { store.set(KEY + "-opened", "1"); ping({ type: "open" }); } panel.hidden = false; launch.hidden = true; document.body.classList.add("cf-open"); launch.setAttribute("aria-expanded", "true"); if (isPhone() && !onChatEntry()) { try { window.history.pushState({ cfChat: 1 }, ""); } catch (e) {} } if (!isPhone()) setTimeout(() => input.focus(), 30); log.scrollTop = log.scrollHeight; }
  function close(fromBack) { if (panel.hidden) return; panel.hidden = true; launch.hidden = false; document.body.classList.remove("cf-open"); launch.setAttribute("aria-expanded", "false"); if (!isPhone()) launch.focus(); placeLauncher(); if (fromBack !== true && onChatEntry()) { try { window.history.back(); } catch (e) {} } }
  window.addEventListener("popstate", () => { if (!panel.hidden) close(true); });
  // Leaving the page from inside the chat (product, cart, any link): close it so it never comes back over the next page.
  panel.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (!a || a.target || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    panel.hidden = true; launch.hidden = false; document.body.classList.remove("cf-open"); launch.setAttribute("aria-expanded", "false");
    // Swap out the chat's Back entry so Back from the product goes straight to this page.
    if (onChatEntry()) { e.preventDefault(); window.location.replace(a.href); }
  });
  launch.addEventListener("click", open);
  $(".cf__close").addEventListener("click", close);
  panel.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

  function el(tag, cls, text) { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  function card(p) {
    const c = el("article", "cf__card");
    const imgLink = el("a", "cf__img" + (p.image ? "" : " cf__img--none")); imgLink.href = p.url; imgLink.setAttribute("aria-hidden", "true"); imgLink.tabIndex = -1;
    if (p.image) { const img = el("img"); img.src = p.image; img.alt = ""; img.loading = "lazy"; img.decoding = "async"; img.width = 480; img.height = 480; imgLink.append(img); }
    else imgLink.textContent = p.type || "BB";
    const body = el("div", "cf__body");
    const name = el("a", "cf__name", p.title); name.href = p.url;
    const ff = el("span", "cf__ff" + (/ripped live/i.test(p.fulfillment) ? " cf__ff--live" : ""), p.fulfillment);
    body.append(name, ff);
    let sel = null;
    if (p.variants.length > 1) {
      sel = el("select", "cf__opt"); sel.setAttribute("aria-label", T.option + ": " + p.title);
      for (const v of p.variants) { const o = el("option", null, v.name + " · " + money(v.price)); o.value = v.id; sel.append(o); }
      sel.value = p.defaultVariant || p.variants[0].id;
      body.append(sel);
    }
    const row = el("div", "cf__row"), price = el("span", "cf__price"), add = el("button", "cf__add", T.add); add.type = "button";
    const current = () => p.variants.find((v) => v.id === (sel ? sel.value : p.variants[0].id)) || p.variants[0];
    const paint = () => { const v = current(); price.textContent = money(v.price); if (v.compareAt && v.compareAt > v.price) price.append(el("s", null, money(v.compareAt))); };
    if (sel) sel.addEventListener("change", paint);
    paint();
    add.addEventListener("click", async () => {
      add.setAttribute("aria-busy", "true");
      const ok = await addToCart([{ id: Number(current().id), quantity: 1 }]);
      add.removeAttribute("aria-busy");
      add.textContent = ok ? T.added : T.add_failed;
      if (ok) { const v = current(); ping({ type: "add", variantId: v.id, title: p.title, variant: v.name, price: v.price }); openDrawer(); }
      setTimeout(() => { add.textContent = T.add; }, 2500);
    });
    row.append(price, add); body.append(row); c.append(imgLink, body);
    return c;
  }

  // Want list: inline "alert me" sign-up when the item isn't in stock.
  const SHOP_BASE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  (function wantStyles() {
    if (document.getElementById("cf-want-css")) return;
    const s = document.createElement("style"); s.id = "cf-want-css";
    s.textContent = ".cf__want{margin-top:10px;padding:12px;border:1px solid rgba(212,175,55,.45);border-radius:10px;background:rgba(212,175,55,.08);display:grid;gap:8px}" +
      ".cf__want-title{font-weight:800;font-size:1rem;line-height:1.3}.cf__want-sub{font-size:.85rem;line-height:1.35;opacity:.85;margin-top:-4px}.cf__want input[type=email],.cf__want input[type=tel]{width:100%;box-sizing:border-box;padding:10px 12px;border-radius:8px;border:1px solid rgba(128,128,128,.45);background:transparent;color:inherit;font:inherit}" +
      ".cf__want-sms{display:flex;gap:8px;align-items:flex-start;font-size:.72rem;line-height:1.35;opacity:.85}.cf__want-sms input{margin-top:2px;flex:none}.cf__want-sms a,.cf__want-note a{color:inherit}" +
      ".cf__want-note{font-size:.72rem;opacity:.7;line-height:1.35}.cf__want button{padding:10px 14px;border:0;border-radius:8px;background:#D4AF37;color:#0D0D13;font-weight:700;cursor:pointer;font:inherit;font-weight:700}" +
      ".cf__want button[disabled]{opacity:.6;cursor:wait}.cf__want-done{font-weight:600;font-size:.9rem}.cf__want-done a{color:inherit}" +
      "@media (max-width:600px){.cf__panel{z-index:190}body.cf-open{overflow:hidden}body.cf-open .bb-tabbar{display:none!important}.cf__close{width:40px;height:40px;font-size:1.5rem}}";
    document.head.appendChild(s);
  })();

  function wantForm(m) {
    const box = el("form", "cf__want");
    box.noValidate = true;
    const done = (label, inStock) => {
      box.textContent = "";
      box.append(el("div", "cf__want-done", "You're on the list for " + label + ". We'll reach out when it lists or a break has the spot open."));
      (inStock || []).forEach((p) => { const a = el("a", "cf__want-done", "In stock now: " + p.title + " · " + money(p.price)); a.href = p.url; box.append(a); });
    };
    if (m.wantDone) { done(m.wantDone, []); return box; }
    // pass 42: lead with "Text me when it lists" (phone first; email optional).
    box.append(el("div", "cf__want-title", "📲 Text me when it lists"));
    box.append(el("div", "cf__want-sub", "We'll text you the moment " + m.wantOffer.label + " comes in or a break has the spot open."));
    const email = el("input"); email.type = "email"; email.placeholder = "Email (optional)"; email.autocomplete = "email"; email.setAttribute("aria-label", "Email");
    const phone = el("input"); phone.type = "tel"; phone.placeholder = "Mobile number"; phone.autocomplete = "tel"; phone.inputMode = "tel"; phone.setAttribute("aria-label", "Mobile number");
    const smsRow = el("label", "cf__want-sms"); const sms = el("input"); sms.type = "checkbox";
    const smsText = el("span");
    smsText.innerHTML = "Text me alerts. I agree to receive recurring automated marketing texts from The Ballers Bank at this number. Consent isn't a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply STOP to cancel, HELP for help. <a href=\"" + SHOP_BASE + "policies/privacy-policy\" target=\"_blank\">Privacy</a> · <a href=\"" + SHOP_BASE + "policies/terms-of-service\" target=\"_blank\">Terms</a>";
    smsRow.append(sms, smsText);
    const note = el("div", "cf__want-note", "By adding an email you'll also get emails from The Ballers Bank. Unsubscribe anytime.");
    const btn = el("button", null, "Text me when it lists"); btn.type = "submit";
    const err = el("div", "cf__err"); err.hidden = true;
    const label = () => { btn.textContent = (!phone.value.trim() && email.value.trim()) ? "Email me when it lists" : "Text me when it lists"; };
    phone.addEventListener("input", label);
    email.addEventListener("input", label);
    box.append(phone, smsRow, email, note, btn, err);
    box.addEventListener("submit", async (e) => {
      e.preventDefault();
      err.hidden = true;
      const em = email.value.trim(), ph = phone.value.trim();
      if (!em && !(ph && sms.checked)) { err.textContent = ph ? "Check the box under your number to get texts." : "Add your mobile number (or an email)."; err.hidden = false; return; }
      btn.disabled = true; btn.textContent = "Saving...";
      try {
        const r = await fetch(API + "/api/want", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ offer: m.wantOffer, email: em, phone: ph, emailOk: Boolean(em), smsOk: Boolean(ph && sms.checked), source: "chat" }) });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error === "bad_email" ? "That email doesn't look right." : data.error === "bad_phone" ? "That phone number doesn't look right." : "Couldn't save that. Try again in a moment.");
        m.wantDone = data.label || m.wantOffer.label; save();
        done(m.wantDone, data.inStock);
      } catch (x) {
        err.textContent = x.message; err.hidden = false; btn.disabled = false; label();
      }
    });
    return box;
  }

  function renderMsg(m) {
    if (m.role === "user") { log.append(el("div", "cf__msg cf__msg--me", m.content)); return null; }
    const b = el("div", "cf__msg cf__msg--bot");
    if (m.content) b.append(el("div", "cf__text", m.content));
    if (m.products && m.products.length) { const g = el("div", "cf__cards"); m.products.forEach((p) => g.append(card(p))); b.append(g); }
    if (m.wantOffer) b.append(wantForm(m));
    if (m.added && m.added.length) {
      const a = el("div", "cf__added", T.added_to_cart + " ");
      const link = el("a", null, T.view_cart); link.href = SHOP_ROOT + "cart"; a.append(link); b.append(a);
    }
    log.append(b);
    return b;
  }

  function renderAll() {
    log.textContent = "";
    const hello = el("div", "cf__msg cf__msg--bot");
    hello.append(el("div", "cf__text", T.hello));
    if (!history.length) {
      const chips = el("div", "cf__chips");
      T.chips.forEach((t) => { const c = el("button", "cf__chip", t); c.type = "button"; c.addEventListener("click", () => ask(t)); chips.append(c); });
      hello.append(chips);
    }
    log.append(hello);
    history.forEach(renderMsg);
    log.scrollTop = log.scrollHeight;
  }

  async function cartItems() {
    try {
      const c = await fetch(SHOP_ROOT + "cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
      return (c.items || []).map((i) => ({ title: i.product_title, variant: i.variant_title || "", qty: i.quantity }));
    } catch (e) { return []; }
  }

  async function addToCart(items) {
    try {
      const r = await fetch(SHOP_ROOT + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
      if (!r.ok) return false;
      await tagCart();
      await refreshCart();
      return true;
    } catch (e) { return false; }
  }

  async function refreshCart() {
    try {
      const html = await fetch(SHOP_ROOT + "?section_id=cart-drawer").then((r) => r.text());
      const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("#shopify-section-cart-drawer");
      const cur = document.querySelector("#shopify-section-cart-drawer");
      if (fresh && cur) cur.replaceWith(fresh);
      const cart = await fetch(SHOP_ROOT + "cart.js").then((r) => r.json());
      document.querySelectorAll("[data-cart-count]").forEach((n) => { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    } catch (e) {}
  }

  function openDrawer() { const opener = $("[data-cart-drawer-open]"); if (opener && document.querySelector("#CartDrawer")) opener.click(); }

  function errorCopy(status, code) {
    if (status === 429 && code === "daily_cap") return T.err_busy;
    if (status === 429) return T.err_slow;
    if (status === 503) return T.err_offline;
    return T.err_generic;
  }

  async function ask(text) {
    text = String(text || "").trim().slice(0, 500);
    if (!text || busy) return;
    if (panel.hidden) open();
    if (!API) { const b = renderMsg({ role: "assistant", content: "" }); b.append(el("div", "cf__err", T.err_offline)); return; }
    busy = true; sendBtn.disabled = true; input.value = "";
    const chips = log.querySelector(".cf__chips"); if (chips) chips.remove();
    history.push({ role: "user", content: text }); save(); renderMsg(history[history.length - 1]);
    const pending = el("div", "cf__msg cf__msg--bot"); pending.append(el("div", "cf__status", T.searching)); log.append(pending); log.scrollTop = log.scrollHeight;

    const turns = history.slice(-12).map((m) => ({
      role: m.role,
      content: m.role === "assistant" && m.products && m.products.length
        ? (m.content || "") + "\n[Cards shown, in order: " + m.products.map((p) => p.id + " = " + p.title).join(" | ") + "]"
        : (m.content || "(no reply)"),
    }));
    try {
      const res = await fetch(API + "/api/chat", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages: turns, cart: await cartItems() }) });
      const data = await res.json().catch(() => ({}));
      pending.remove();
      if (!res.ok) { history.pop(); save(); const b = renderMsg({ role: "assistant", content: "" }); b.append(el("div", "cf__err", errorCopy(res.status, data.error))); return; }
      let added = [];
      if (data.cartAdds && data.cartAdds.length) {
        const ok = await addToCart(data.cartAdds.map((a) => ({ id: Number(a.variantId), quantity: Number(a.qty) || 1 })));
        if (ok) added = data.cartAdds; else data.reply = (data.reply || "") + "\n" + T.add_failed_long;
      }
      const msg = { role: "assistant", content: data.reply || "", products: data.products || [], added, wantOffer: data.wantOffer || null };
      history.push(msg); save(); renderMsg(msg);
    } catch (e) {
      pending.remove(); history.pop(); save();
      const b = renderMsg({ role: "assistant", content: "" }); b.append(el("div", "cf__err", T.err_generic));
    } finally {
      busy = false; sendBtn.disabled = false; log.scrollTop = log.scrollHeight;
    }
  }

  form.addEventListener("submit", (e) => { e.preventDefault(); ask(input.value); });

  // Entry points anywhere on the site (search dropdown, search page, homepage box).
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-card-finder-ask]");
    if (!t || root.contains(t)) return;
    e.preventDefault();
    const q = t.dataset.cfQuery || "";
    if (q) ask(q); else open();
  });
  document.addEventListener("submit", (e) => {
    const f = e.target.closest("[data-card-finder-form]");
    if (!f) return;
    e.preventDefault();
    const field = f.querySelector("input");
    const q = field ? field.value : "";
    if (field) field.value = "";
    if (q.trim()) ask(q); else open();
  });
  window.BBCardFinder = { open, ask };

  // Share the bottom-left corner with other widgets (e.g. the Klaviyo "$10 off" teaser):
  // if something else is pinned there, stack the bubble just above it.
  function placeLauncher() {
    if (launch.hidden) return;
    launch.style.bottom = "";
    const mine = launch.getBoundingClientRect();
    let lift = 0;
    document.querySelectorAll('body > *, [class*="kl-teaser"]').forEach((n) => {
      if (n === root || root.contains(n) || n.contains(root) || n.id === "CartDrawer" || n.id === "PBarNextFrameWrapper") return;
      const s = getComputedStyle(n);
      if (s.position !== "fixed" || s.display === "none" || s.visibility === "hidden" || Number(s.opacity) === 0) return;
      const r = n.getBoundingClientRect();
      if (r.width < 20 || r.height < 20 || r.height > 220 || r.width > window.innerWidth * 0.8) return;
      if (r.left > mine.right || r.right < mine.left || r.bottom < mine.top - 4) return;
      lift = Math.max(lift, window.innerHeight - r.top + 12);
    });
    if (lift) launch.style.bottom = lift + "px";
  }
  let placeTimer = null;
  const schedulePlace = () => { clearTimeout(placeTimer); placeTimer = setTimeout(placeLauncher, 150); };
  new MutationObserver(schedulePlace).observe(document.body, { childList: true, subtree: false });
  window.addEventListener("resize", schedulePlace);
  [1000, 3000, 9000, 15000, 30000].forEach((ms) => setTimeout(placeLauncher, ms));

  renderAll();
  // A page loaded fresh on a leftover chat history entry: drop it so Back works normally.
  if (onChatEntry()) { try { window.history.replaceState(null, ""); } catch (e) {} }
  // Back from another page can restore this one from cache; make sure the chat isn't left covering it.
  window.addEventListener("pageshow", (e) => { if (e.persisted && !panel.hidden && !onChatEntry()) close(true); });
})();
